/**
@ngdoc service
@name timestampUrl

@description
Adds timestamp with current date to url (mostly to prevent ajax call caching).
*/
(function() {
    'use strict';

	var timestampUrl = function() {
		return {
		    add: function( url ) {
		        return url + ((url.indexOf('?') == -1) ? '?' : '&') + 'angularTimestampHash=' + Date.now();
		    }
		}
	}
	angular.module('app').factory('timestampUrl', timestampUrl);

})();